import { Grid, styled, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"

const ErrorTitle = styled(Typography)({
  marginBottom: "20px"
})

const AnonymousUserMessage = () => {
  const { t } = useTranslation()

  return (
    <Grid item xs={12}>
      <ErrorTitle variant="h1">{t("dashboard.something_went_wrong", "Something went wrong")}</ErrorTitle>
      <Typography variant="bodyMedium">
        {t(
          "dashboard.account_not_linked",
          "You have come to this page because your account exists, but is not correctly linked to a customer."
        )}
      </Typography>
      <Typography variant="bodyMedium">
        {t("dashboard.contact_support", "Please contact your system manager or Cloudplanning's support.")}
      </Typography>
    </Grid>
  )
}

export default AnonymousUserMessage
